var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2862_2633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 28C21.7321 28 28 21.7321 28 14C28 6.26792 21.7321 0 14 0C6.26792 0 0 6.26792 0 14C0 21.7321 6.26792 28 14 28Z",
    fill: "#D6001C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96246 7.68164V12.444C8.68754 11.5795 9.55671 11.1443 10.5647 11.1443C11.0839 11.1443 11.5488 11.2435 11.9659 11.4401C12.3841 11.6355 12.6968 11.8863 12.908 12.1908C13.1203 12.4982 13.2638 12.8348 13.3414 13.2058C13.4184 13.5751 13.4569 14.1496 13.4569 14.929V20.0209H11.204V15.4347C11.204 14.5247 11.1632 13.9484 11.0775 13.7034C10.9971 13.4634 10.8377 13.2577 10.6254 13.1201C10.4084 12.9736 10.1383 12.9013 9.8122 12.9013C9.43887 12.9013 9.10404 12.9946 8.81296 13.1801C8.51546 13.3668 8.30196 13.6456 8.16662 14.0184C8.02896 14.3917 7.96012 14.943 7.96246 15.6727L7.96012 20.0209H5.71021V7.68164H7.96304M16.8332 7.68164V12.444C17.5589 11.5795 18.4275 11.1443 19.4349 11.1443C19.9523 11.1443 20.4207 11.2435 20.8384 11.4401C21.2549 11.6355 21.5675 11.8863 21.7775 12.1908C21.9895 12.4962 22.1369 12.8415 22.211 13.2058C22.2885 13.5751 22.327 14.1496 22.327 14.929V20.0209H20.0765V15.4347C20.0765 14.5247 20.034 13.9484 19.9482 13.7034C19.8679 13.4631 19.708 13.2573 19.495 13.1201C19.2803 12.9736 19.0079 12.9013 18.6818 12.9013C18.309 12.9013 17.9742 12.9946 17.6825 13.1801C17.3891 13.3668 17.1745 13.6456 17.0374 14.0184C16.902 14.3917 16.8332 14.943 16.8332 15.6727V20.0209H14.5833V7.68164H16.8332Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2862_2633"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHh);
export default __webpack_public_path__ + "static/media/hh.fe66bc698033e67bf2ea75dc8e890e78.svg";
export { ForwardRef as ReactComponent };